import { Injectable } from '@angular/core';
import {UserService} from "./user.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class SecuirtyService {

  constructor(private userService: UserService) { }
    // generatSecretId
    public generateKey(keyObj): Observable<any>{
        return this.userService.request('post', 'generateKey',keyObj)
    }
    // getGenerateKey
    public getGenerateKey(): Observable<any>{
        return this.userService.request('get', 'getGenerateKey')
    }
    public updategenerateKey(keyObj): Observable<any>{
        return this.userService.request('post', 'updategenerateapikey',keyObj)
    }
    public deleteAPIKey(keyid): Observable<any>{
        return this.userService.request('get', 'deleteapikey',null,{keyid:keyid})
    }

    // Authenticator (TOTP) 2FA
    public getAdmin2faStatus(): Observable<any>{
        return this.userService.request('get', 'admin2fa/status')
    }
    public getAdmin2faSetup(): Observable<any>{
        return this.userService.request('get', 'admin2fa/setup')
    }
    public enableAdmin2fa(payload): Observable<any>{
        return this.userService.request('post', 'admin2fa/enable', payload)
    }
    public disableAdmin2fa(payload): Observable<any>{
        return this.userService.request('post', 'admin2fa/disable', payload)
    }
}



// WEBPACK FOOTER //
// ./src/app/services/secuirty.service.ts